import { type FC } from 'react';
import { Stack, Text } from '@mantine/core';
import { formatOrder, type PayoutOrder } from '~/entities/payout';
import { BankIdentity } from './BankIdentity';

interface RequisiteProps {
    requisiteV2: PayoutOrder['requisiteV2'];
}

export const Requisite: FC<RequisiteProps> = ({ requisiteV2 }) => {
    const { card, sbp } = requisiteV2 ?? {};

    return (
        <Stack gap={2}>
            {card?.bankCode && <BankIdentity bankCode={card.bankCode} />}

            {card?.number && <Text size='sm'>{formatOrder.cardNumber(card.number)}</Text>}

            {sbp?.bankCode && <BankIdentity bankCode={sbp.bankCode} />}

            {sbp?.phoneNumber && <Text size='sm'>{formatOrder.phoneNumber(sbp.phoneNumber)}</Text>}
        </Stack>
    );
};
